import React from "react";
import WeatherInfo from "./WeatherInfo";
import MarketInfo from "./MarketInfo";

const TopInfoBar = () => {
    return (
        <div className="top-info-bar">
            <div className="weather"><WeatherInfo /></div>
        </div>
    );
};

export default TopInfoBar;